module.exports = __webpack_public_path__ + "img/slider-background.b05774c3.jpg";